/* eslint-disable */
import $ from 'jquery';
import ko from 'knockout';
import Base from '@bingads-webui-static-legacy/bulk-edit/viewmodel/bulkEditJob';
import actions from '@bingads-webui-static-legacy/schema/bulkEdit/changeBudgetActions';
import PageContext from '@bingads-webui-static-legacy/page-context';
var i18n = window.globalLegacyI18n.get('module/extension/requirejs/i18n!global');
var i18nAmdLoader = window.globalLegacyI18n.get('@bingads-webui/i18n-amd-loader!campaignui/feature/campaigns-tab/campaigns');
var OUT_OF_RANGE = 'OutOfRange';
var INVALID = 'InvalidNumber';
var actionOptions = [{
  Value: actions.Set,
  Text: i18n.getString('BulkEdit_Campaign_SetBudgetOption')
}, {
  Value: actions.Increase,
  Text: i18n.getString('BulkEdit_Campaign_IncreaseBudgetOption')
}, {
  Value: actions.Decrease,
  Text: i18n.getString('BulkEdit_Campaign_DecreaseBudgetOption')
}];
var unitOptions = [{
  Value: 'percentage',
  Text: '%'
}, {
  Value: 'absolute',
  Text: PageContext.AccountCurrencyCode
}];
var regEx = new RegExp(/^[0-9]*\.?[0-9]+$/g);
var validateNumber = function (value, usePercentValidation) {
  if (!i18nAmdLoader.isValidDecimal(value)) {
    return INVALID;
  }
  var minValue = usePercentValidation ? 0 : PageContext.BudgetRange.DailyRange.FloorValue;
  var maxValue = usePercentValidation ? Number.MAX_VALUE : PageContext.BudgetRange.DailyRange.CeilingValue;
  value = i18nAmdLoader.parseDecimal(value, 2).toString();
  if (value.match(regEx)) {
    if (value < minValue && !usePercentValidation || value <= minValue && usePercentValidation || value > maxValue) {
      return OUT_OF_RANGE;
    }
  } else {
    return INVALID;
  }
  return '';
};
var ViewModel = function (model) {
  Base.call(this);
  this.actions = actionOptions;
  this.selectedAction = ko.observable(actions.Set);
  this.selectedAction.subscribe(function () {
    this.errorMessage('');
  }, this);
  this.showSetPanel = ko.computed(function () {
    return this.selectedAction() === actions.Set;
  }, this);
  this.showChangeByPanel = ko.computed(function () {
    return this.selectedAction() === actions.Increase || this.selectedAction() === actions.Decrease;
  }, this);
  this.showIncreaseBudgetHelp = ko.computed(function () {
    return this.selectedAction() === actions.Increase;
  }, this);
  this.units = unitOptions;
  this.selectedUnit = ko.observable('percentage');
  this.budget = ko.observable();
  this.budgetValue = ko.computed({
    read: function () {
      return this.budget();
    },
    write: function (value) {
      this.errorMessage('');
      this.budget(value);
    },
    owner: this
  });
  this.limit = ko.observable();
  this.limitValue = ko.computed({
    read: function () {
      return this.limit();
    },
    write: function (value) {
      this.errorMessage('');
      this.limit(value);
    },
    owner: this
  });
  this.useLimitValue = ko.observable();
  this.limitBudgetLabelText = ko.computed(function () {
    if (this.selectedAction() === actions.Increase) return i18n.getString('BulkEdit_Campaign_UpperCashbackBudgetLimit'); else if (this.selectedAction() === actions.Decrease) return i18n.getString('BulKEdit_Campaign_LowerCashbackBudgetLimit');
  }, this);
  this.selectedEntityCount(model.get('selectedEntityCount'));
  this.titleText = ko.computed(function () {
    return i18n.getString('BulkEdit_Campaign_ChangeCashbackBudgetTitle').replace('{0}', this.selectedEntityCount());
  }, this);
  this.validate = function () {
    this.errorMessage('');
    if (this.selectedEntityCount() === 0) {
      alert(i18n.getString('Grid_RowSelectionRequired'));
      return false;
    }
    var selectedAction = this.selectedAction();
    var usePercentValidation = (selectedAction === actions.Increase || selectedAction === actions.Decrease) && this.selectedUnit() === 'percentage';
    var budgetValue = this.budgetValue();
    if (!budgetValue) {
      if (selectedAction === actions.Set) {
        this.errorMessage(i18n.getString('BulkEdit_Campaign_MissingBudgetError'));
      } else {
        if (this.selectedUnit() === 'percentage') {
          this.errorMessage(i18n.getString('BulkEdit_Keyword_MissingPercentageError'));
        } else {
          this.errorMessage(i18n.getString('BulkEdit_Campaign_MissingBudgetError'));
        }
      }
      return false;
    }
    if (budgetValue) {
      var result = validateNumber(budgetValue, usePercentValidation);
      if (result === OUT_OF_RANGE) {
        this.errorMessage(i18n.getString('BulkEdit_Campaign_BudgetOutOfRangeError'));
        return false;
      } else if (result === INVALID) {
        if (this.selectedUnit() === 'percentage') {
          this.errorMessage(i18n.getString('BulkEdit_Keyword_InvalidPercentageError'));
        } else {
          this.errorMessage(i18n.getString('BulkEdit_Campaign_InvalidBudgetError'));
        }
        return false;
      }
    }
    if (this.useLimitValue() && selectedAction !== actions.Set) {
      var limit = this.limitValue();
      if (!limit) {
        this.errorMessage(i18n.getString('BulkEdit_Campaign_MissingBudgetLimitError'));
        return false;
      } else {
        var result = validateNumber(limit, false);
        if (result === OUT_OF_RANGE) {
          this.errorMessage(i18n.getString('BulkEdit_Campaign_BudgetOutOfRangeError'));
          return false;
        } else if (result === INVALID) {
          this.errorMessage(i18n.getString('BulkEdit_Campaign_InvalidBudgetError'));
          return false;
        }
      }
    }
    return true;
  };
};
export default ViewModel;

